// extracted by mini-css-extract-plugin
export default {"preloader":"sVZ4lD","enabled":"bY3nZD","semi-rotate":"IGUhH8","semiRotate":"IGUhH8","inner-rotate":"GJ9RZq","innerRotate":"GJ9RZq","white":"oWh_uJ","dark":"AVWyDm"};